module.exports = __webpack_public_path__ + "static/media/share_google_sheet.72d3ada4.png";